import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS } from 'src/constants/constants';
import { IDeleteSectionPayload } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

const deleteRotationScreenSection = async (payload: IDeleteSectionPayload) => {
  const rotationSections = payload.screen.sections.filter(
    (section) => section.config?.events?.SECTION_TIMER !== undefined,
  );

  const deleteRequests = rotationSections.map((rotationSection) => ({
    resource: COLLECTIONS.SCREEN_SECTIONS,
    id: rotationSection?.screenSectionId,
    method: 'DELETE',
  }));

  if (deleteRequests.length > 0) {
    await requestCCApi({
      url: '/transaction',
      method: 'POST',
      data: {
        data: deleteRequests,
      },
    });
  }
};

export const useDeleteRotationScreenSection = () => {
  return useMutation({
    mutationFn: deleteRotationScreenSection,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.screenSections.invalidateAll());
      queryClient.invalidateQueries(queryKeys.layoutScreens.invalidateAll());
      queryClient.invalidateQueries(queryKeys.layouts.invalidateAll());
    },
  });
};
